export function isChineseIP(ip) {
    // 定义中国IP段范围
    var chinaRanges = [
        "1.0.0.0",   "255.255.255.254",
        "60.97.83.0", "60.97.83.255",
        "60.97.83.0", "60.97.83.255",
    ]
    
    for (var i = 0; i < chinaRanges.length; i += 2) {
        if ((ip >= chinaRanges[i]) && (ip <= chinaRanges[i + 1])) {
            return true;
        }
    }
    
    return false;
}

//去掉查询参数 ？ & 后面的参数
export function getPurePath(url) {
    return url.replace(/\?.*$/, '');
}

//判断url中是否存在某个参数
export function hasUrlParam(key) {
    return window.location.href.indexOf(key+"=") > -1;
    // const params = new URLSearchParams(window.location.search);
    // return params.has(key); // 返回 true 或 false
}

//获取url中某个参数的值
export function getUrlParam(name) {
    let params_str = location.search.substring(1);
    var reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
    var result = params_str.match(reg);
    if (result === null) {
      return null;
    }
    return decodeURIComponent(result[2]);
}



// WEBPACK FOOTER //
// ./src/utils/index.js